import config from '../config/printer';

export const Printer = function (qztray) {
        /** @type {QzTray} */
        this.qztray = qztray;

        this.getPrinterStatus = function (printer) {
            const settings = JSON.parse(localStorage.getItem('settings')) || false;
            if (!settings) {
                return printer;
            }
            switch (printer) {
                case 'barcode':
                    return settings.printer.barcodePrinter;
                case 'zebra':
                    return settings.printer.zebraPrinter;
                case 'letter':
                case 'letterhead':
                    return settings.printer.letterPrinter;
                case 'fedex':
                    return settings.printer.fedexPrinter;
                case 'usps':
                    return settings.printer.uspsPrinter;
            }
            return printer;
        };

        /**
         * Print raw data
         *
         * @param printer
         * @param data
         * @returns {*}
         */
        this.printRaw = (printer, data) => {
            let self = this;

            printer = this.getPrinterStatus(printer);
            if (!self.qztray.connected) {
                console.warn('No connection with QZ is active.');
                return;
            }

            if (typeof data === 'string') {
                data = data.split(/[\t]*[\r\n]+[ \t]*/g);
            }

            let printOptions = config.printOptions || {};
            let qzConfig = self.qztray.qz.configs.create(printer, printOptions);

            return new Promise((resolve, reject) => {
                self.qztray.qz.print(qzConfig, data).then(() => {
                    resolve();
                }).catch(function (e) {
                    console.error(e);
                    errorToast(e.message);
                    reject(e);
                });
            });
        };

        /**
         * Print base64 encoded data
         *
         * @param printer
         * @param encodedData
         * @returns {*}
         */
        this.print = (printer, encodedData) => {
            let self = this;

            printer = this.getPrinterStatus(printer);
            if (!self.qztray.connected) {
                console.warn('No connection with QZ is active.');
                return;
            }

            let printOptions = config.printOptions || {};
            let qzConfig = self.qztray.qz.configs.create(printer, printOptions);

            let data = [{
                type: 'raw',
                format: 'command',
                flavor: 'base64',
                data: encodedData,
            }];

            return new Promise((resolve, reject) => {
                self.qztray.qz.print(qzConfig, data).then(() => {
                    resolve();
                }).catch(function (e) {
                    console.error(e);
                    errorToast(e.message);
                    reject(e);
                });
            });
        };

        /**
         * Print base64 encoded PDF data
         *
         * @param printer
         * @param encodedData
         * @returns {*}
         */
        this.printPDF = (printer, encodedData) => {
            let self = this;

            printer = this.getPrinterStatus(printer);
            if (!self.qztray.connected) {
                console.warn('No connection with QZ is active.');
                return;
            }

            let printOptions = config.printOptions || {};
            let qzConfig = self.qztray.qz.configs.create(printer, printOptions);

            let data = [{
                type: 'pixel',
                format: 'pdf',
                flavor: 'base64',
                data: encodedData,
            }];

            return new Promise((resolve, reject) => {
                self.qztray.qz.print(qzConfig, data).then(() => {
                    resolve();
                }).catch(function (e) {
                    console.error(e);
                    errorToast(e.message);
                    reject(e);
                });
            });
        };
    }
;

function errorToast(message) {
    const h = vm.$createElement;
    const vNodesMsg = h(
        'div',
        {class: 'd-flex align-items-center'},
        [
            h('div',
                {class: 'mr-2'},
                [
                    h('i', {class: 'fa-duotone fa-print-slash fa-fw fa-2x fa-pull-left text-danger'}, ''),
                ]
            ),
            h('div',
                {class: 'flex-fill'},
                [
                    h('strong', 'Printer Error.'),
                    h('button', {
                        class: 'close ml-auto mb-1',
                        on: {click: () => vm.$bvToast.hide('printer-error-toast')}
                    }, '×'),
                    h('div', {class: 'font-xs'}, `${message}`),
                    h('a', {class: 'font-xs', attrs: {href: '/profile/settings', target: '_blank'}}, [
                        'Open Settings',
                        h('i', {class: 'fa-duotone fa-external-link fa-fw'}, ''),
                    ])
                ]
            ),
        ],
    );
    vm.$bvToast.toast([vNodesMsg], {
        variant: 'secondary',
        toaster: 'b-toaster-bottom-right',
        id: 'printer-error-toast',
        autoHideDelay: 10000,
        noAutoHide: true,
        noCloseButton: true,
    });
}

export default Printer;
